import React, { useState, useEffect } from 'react';
import { useHistory } from 'react-router-dom';

import key from '../../../assets/bx_bxs-key.svg';
import user from '../../../assets/bx_bxs-user.svg';
import fb from '../../../assets/fb icon.svg';
import google from '../../../assets/google icon.svg';
import linkedin from '../../../assets/Linkedin icon.svg';
import login from '../../../assets/login.png';
import twitter from '../../../assets/twitter icon.svg';
import { signIn, signInWithSSO } from '../../../auth/Auth';
import { auth } from '../../../auth/Config';
import Button from '../../../components/Button';
import TextInput from '../../../components/TextInput';
import { SIGN_IN_FORM } from '../../../constants/FormNames';
import { AuthTypes } from '../../../constants/Types';
import { checkHasErrors } from '../../../constants/Validations';

const Login = ({ formData, editModal }) => {
	const navigate = useHistory();
	const [loginError, setloginError] = useState(false);

	const onSucess = async (data: any) => {
		if (data.userName) {
			navigate.push(`/${data.userName}`);
		} else {
			editModal({
				name: 'userName',
				title: 'Username',
				handleEditState: data => {
					if (data.userName) {
						navigate.push(`/${data.userName}`);
					}
				},
			});
		}
		// console.log('FIREBASE AUTH TOKEN', await auth.currentUser?.getIdToken());
	};

	const onError = (error?: string) => {
		console.log(error);
		setloginError(true);
	};

	const handleLogin = () => {
		signIn(formData?.username, formData?.password, onSucess, onError);
	};

	const onPressFacebookSignIn = () =>
		signInWithSSO(AuthTypes.FACEBOOK, onSucess, onError);
	const onPressGoogleSignIn = () =>
		signInWithSSO(AuthTypes.GOOGLE, onSucess, onError);
	const onPressLinkedIn = () =>
		signInWithSSO(AuthTypes.LINKEDIN, onSucess, onError);
	const onPressTwitterSignIn = () =>
		signInWithSSO(AuthTypes.TWITTER, onSucess, onError);

	const disabled = () => {
		return checkHasErrors(SIGN_IN_FORM, ['username', 'password']) || loginError;
	};

	useEffect(() => {
		console.log(navigate);
	}, []);

	return (
		<div className='signup__container'>
			<div className='signup__box'>
				<span className='company__name'>
					<span onClick={() => navigate.push('/home')}>Webbler</span>
				</span>
				<span className='signup_text'>
					New user? <span onClick={() => navigate.push('/signup')}>Sign up</span>
				</span>
				<div className='box'>
					<div className='img_wrap'>
						<img className='login_img' src={login} alt='Login image' />
					</div>
					<div className='form'>
						<div className='text_box'>
							<h3 className='welcome'>Welcome Back!</h3>
							<h6 className='welcome_sub1'>sign into your account</h6>
						</div>
						<div className='inputbox-container'>
							<div className='input_box'>
								<TextInput
									onFocus={() => setloginError(false)}
									type='text'
									name='username'
									transform='lower'
									id='username'
									placeholder='Username or email address'
									form={SIGN_IN_FORM}
									validations={[]}
									hidden={false}
									rightSideIcon={null}
									mainIcon={user}
								/>
								<TextInput
									onFocus={() => setloginError(false)}
									type='password'
									name='password'
									id='password'
									placeholder='Password'
									form={SIGN_IN_FORM}
									validations={[]}
									hidden={false}
									rightSideIcon={null}
									mainIcon={key}
								/>
								<span
									className={
										loginError ? 'form-error-message visible' : 'form-error-message'
									}
								>
									Username or Password invalid!
								</span>
							</div>
						</div>
						<div className='bottom_group'>
							<div className='btn_box'>
								<Button
									active
									diactivated={disabled()}
									clicked={!loginError}
									className='sign'
									labal={'Sign In'}
									onClickEvent={() => handleLogin()}
								/>
								<Button
									className='forget_ps'
									labal={'FORGOT PASSWORD?'}
									onClickEvent={() => {
										navigate.push('/forgot-password');
									}}
								/>
							</div>
							<div className='sso_1'>
								<div className='sso__icons1'>
									<div className='sso-caption'>
										<div className='line'></div>
										<span>Sign in with</span>
										<div className='line'></div>
									</div>
									<div className='image-button-wrapper'>
										<img
											src={fb}
											alt='fb image'
											aria-hidden='true'
											onClick={onPressFacebookSignIn}
										/>
										<img
											src={google}
											alt='google image'
											aria-hidden='true'
											onClick={onPressGoogleSignIn}
										/>

										<img
											src={linkedin}
											alt='linkedin image'
											aria-hidden='true'
											onClick={onPressLinkedIn}
										/>
										<img
											src={twitter}
											alt='twitter image'
											aria-hidden='true'
											onClick={onPressTwitterSignIn}
										/>
									</div>
								</div>
							</div>
							<div className='signup_bottom'>
								Don't have an account?
								<span onClick={() => navigate.push('/signup')}>Sign up</span>
							</div>
						</div>
					</div>
				</div>
			</div>
		</div>
	);
};

export default Login;
